module.exports = __webpack_public_path__ + "b632d1664bcd41dd5776a920839baa1d.png";